<script>
import ModelShow from "../models/show";
import Row from "@/components/models/show/custom-row";

export default {
  extends: ModelShow,
  page: {
    title: "Detail Service",
  },
  props: {
    cardTitle: {
      default() {
        return this.lodash.startCase(this.$t("services.singular"));
      },
    },
    resourceRoute: { default: "services" },
    modelVariable: { default: "company" },
    denyEdit: {
      type: Boolean,
      default() {
        return true;
      },
    },
    denyDelete: { type: Boolean, default: true },
    columns: {
      type: Object,
      default() {
        return {
          [this.modelVariable || "model"]: [
            {
              key: "key",
              label: this.$t("models.key"),
              component: Row,
            },
          ],
        };
      },
    },
  },
  data() {
    return {
      title: this.lodash.startCase(this.$t("services.plural")),
    };
  },
  mounted() {
    this.fetchModel();
  },
  computed: {
    items() {
      return [
        {
          text: this.lodash.startCase(this.$t("services.plural")),
          href: "/services",
        },
        {
          text:
            this.model && this.model.id
              ? this.model["name"]
              : this.$route.params.key,
          href: `/services/${this.$route.params.key}`,
          active: true,
        },
      ];
    },
    modelMapped() {
      return this.lodash.isEmpty(this.model)
        ? []
        : [
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.name`)),
              value: this.model.name,
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`${this.resourceRoute}.fee`)),
              value: this.$numeral(this.model.fee).format("$ 0,0.[000]"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`purchase_orders.top`)),
              value: this.model.duration ?? '-',
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(
                  this.$t(`${this.resourceRoute}.customer_type`)
              ),
              value: this.lodash.upperCase(this.model.customer_type),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: 'Kategori',
              value: this.model.type ? this.lodash.upperFirst(this.$t(`shrimps.types.${this.model.type}`)) : '-',
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t('services.is_active')),
              value: this.lodash.startCase(this.model.is_active ? this.$t('services.active') : this.$t('services.inactive')),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
            },
            {
              key: this.lodash.startCase(this.$t(`CreatedBy`)),
              value: this.lodash.startCase(this.model.creator?.name || "-"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              styles: { fontSize: "10px", opacity: "0.8" },
            },
            {
              key: this.lodash.startCase(
                this.$t(`${this.resourceRoute}.created_at`)
              ),
              value: this.$moment
                .utc(this.model.created_at)
                .local()
                .format("DD MMMM YYYY"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              styles: { fontSize: "10px", opacity: "0.8" },
              _denyShow: this.model.isUpdated,
            },
            {
              key: this.lodash.startCase(
                this.$t(`${this.resourceRoute}.updated_at`)
              ),
              value: this.$moment
                .utc(this.model.updated_at)
                .local()
                .format("DD MMMM YYYY"),
              class: "row",
              labelClass: "col-sm-12 col-md-3",
              valueClass: "col-sm-12 col-md-9",
              showColon: true,
              styles: { fontSize: "10px", opacity: "0.8" },
              _denyShow: !this.model.isUpdated,
            },
            // {
            //   item: this.model,
            //   value: {
            //     props: {
            //       item: {
            //         type: Object,
            //         default: () => ({}),
            //       }
            //     },
            //     template: `
            //     <div class="row" style="fontSize: 10px; opacity: 0.8">
            //       <div class="col-md-3 row">
            //         <div class="col-md-3">{{lodash.startCase($t('CreatedBy'))}}</div>
            //         <div class="col-md-9">{{item.creator?.name}}</div>
            //       </div>
            //       <div class="col-md-3 row">
            //         <div class="col-md-3">{{$t('services.created_at')}}</div>
            //         <div class="col-md-9">{{item.created_at}}</div>
            //       </div>
            //       <div class="col-md-3 row">
            //         <div class="col-md-3">{{lodash.startCase($t('UpdatedBy'))}}</div>
            //         <div class="col-md-9">{{item.updater?.name}}</div>
            //       </div>
            //       <div class="col-md-3 row">
            //         <div class="col-md-3">{{lodash.startCase($t('CreatedBy'))}}</div>
            //         <div class="col-md-9">{{item.updater?.name}}</div>
            //       </div>
            //     </div>
            //     `,
            //   }
            // },
          ].filter((item) => !item._denyShow);
    },
  },
  methods: {
    delete() {
      return this.$axios.delete(`/shrimps/${this.$route.params.key}`);
    },
    fetchModel() {
      this.loading = true;
      return this.$axios
        .get(`/shrimps/${this.$route.params.key}`, {
          params: {
            with: ['creator', 'updater'].join(','),
          }
        })
        .then((response) => {
          const {
            data: { data },
          } = response;
          // if created_at and updated_at is different, then it is updated
          data.isUpdated = data.created_at !== data.updated_at;
          this.model = data;
          return response;
        })
        .catch((error) => this.failedAlert(error))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
